class TipoSituacaoContrato {
  constructor(dados) {
    this.id = dados.id;
    this.nome = dados.nome;
  }
}
export default TipoSituacaoContrato;
